<template>
    <div class="flex flex-col py-10 px-5">
        <div class="mx-auto text-center flex flex-col items-center">
            <router-link :to="isLoggedIn ? '/client' : '/login'" class="text-sm">Assurance déja activée ? Cliquez-ici pour accéder à votre compte</router-link>
            <span class="mt-2 text-4xl font-bold text-wecare-red uppercase">J'active mon assurance</span>
            <img src="@/assets/img/logo.svg" class="h-10 w-auto relative -mr-2" />
            <span class="mt-2 text-2xl font-medium text-wecare-red uppercase">En 2 étapes</span>
        </div>

        <div class="flex mx-auto w-full justify-between mt-5" style="max-width: 300px">
            <div class="uppercase flex flex-col text-center">
                <img src="@/assets/img/steps/account-ok.svg" class="h-24 w-auto relative" style="right: -20px" v-if="step === 'insurance' || step === 'thanks'"/>
                <img src="@/assets/img/nav/account.svg" class="h-24 w-auto" v-else />

                <span class="font-medium mt-2" :class="step === 'account' ? '' : 'text-gray-600'">Je crée</span>
                <span class="font-bold text-wecare-red" :class="step === 'account' ? '' : 'grayscale'">mon compte</span>
                <img src="@/assets/img/steps/1-black.svg" :class="step === 'insurance' ? '' : 'grayscale opacity-50'" class="w-auto h-8 mt-1"/>
            </div>

            <div class="uppercase flex flex-col text-center">
                <img src="@/assets/img/steps/activation-ok.svg" class="h-24 w-auto relative" style="right: -20px" v-if="step === 'thanks'"/>
                <img src="@/assets/img/nav/activation.svg" class="h-24 w-auto" :class="step === 'insurance' ? '' : 'opacity-50'" v-else />

                <span class="font-medium mt-2" :class="step === 'insurance' ? '' : 'text-gray-600'">J'active mon</span>
                <span class="font-bold text-wecare-red" :class="step === 'insurance' ? '' : 'grayscale'">assurance</span>
                <img src="@/assets/img/steps/2-black.svg" :class="step === 'insurance' ? '' : 'grayscale opacity-50'" class="w-auto h-8 mt-1"/>
            </div>
        </div>

        <div class="flex flex-col items-center justify-center w-full mx-auto bg-white border border-gray-600 my-6 py-10 px-5 login-form bg-login-form rounded-lg" style="border-color: rgb(216, 221, 228); max-width: 1200px;">
            <div class="flex flex-col w-full items-center" v-if="step == 'account'">
                <img src="@/assets/img/nav/account.svg" class="h-24 w-auto" />
                <span class="text-black text-4xl font-bold mt-2 text-center">Je crée <span class="text-wecare-red">mon compte</span></span>

                <form class="flex flex-col w-full my-5" @submit.prevent="validateAccount">
                    <div class="flex flex-col md:flex-row w-full">
                        <aff-input v-model="formAccount.firstname" label="Prénom" type="text" :errors="errors && errors.firstname ? errors.firstname : null" class="w-full sm:px-10"/>
                        <aff-input v-model="formAccount.lastname" label="Nom" type="text" :errors="errors && errors.lastname ? errors.lastname : null" class="w-full sm:px-10"/>
                    </div>

                    <div class="flex flex-col md:flex-row w-full">
                        <aff-input label="E-mail" v-model="formAccount.email" :errors="errors && errors.email ? errors.email : null" type="email" class="w-full sm:px-10"/>
                        <aff-input label="Numéro de téléphone" v-model="formAccount.phone" :errors="errors && errors.phone ? errors.phone : null" type="phone" class="w-full sm:px-10"/>
                    </div>

                    <div class="flex flex-col md:flex-row w-full">
                        <aff-input label="Adresse postale" class="w-full sm:px-10" v-model="formAccount.address_1" :errors="errors && errors.address_1 ? errors.address_1 : null" type="text"/>
                        <aff-input label="Code postal" class="w-full sm:px-10" v-model="formAccount.address_postcode" :errors="errors && errors.address_postcode ? errors.address_postcode : null" type="text"/>
                    </div>

                    <div class="flex flex-col md:flex-row w-full sm:w-1/2">
                        <aff-input label="Ville" class="sm:px-10" v-model="formAccount.address_city" :errors="errors && errors.address_city ? errors.address_city : null" type="text"/>
                    </div>

                    <div class="mt-10 mx-auto flex">
                        <input type="submit" class="btn h-20 cursor-pointer border border-wecare-red bg-wecare-red hover:scale-105 hover:bg-white hover:text-wecare-red" value="Je crée mon compte" v-if="!isLoading" />

                        <span class="btn h-20 bg-wecare-red cursor-wait" v-else>
                            <svg version="1.1" class="text-white fill-current" id="loader-1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="25px" height="25px" viewBox="0 0 50 50" style="enable-background:new 0 0 50 50;" xml:space="preserve">
                                <path d="M43.935,25.145c0-10.318-8.364-18.683-18.683-18.683c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615c8.072,0,14.615,6.543,14.615,14.615H43.935z" transform="rotate(19.7256 25 25)">
                                    <animateTransform attributeType="xml" attributeName="transform" type="rotate" from="0 25 25" to="360 25 25" dur="0.6s" repeatCount="indefinite"></animateTransform>
                                </path>
                            </svg>
                        </span>
                    </div>
                </form>
            </div>

            <div class="flex flex-col w-full items-center" v-if="step == 'insurance'">
                <img src="@/assets/img/nav/activation.svg" class="h-24 w-auto" />
                <span class="text-black text-4xl font-bold mt-2 text-center">J'active <span class="text-wecare-red">mon assurance</span></span>

                <form class="flex flex-col w-full my-5" @submit.prevent="submit">
                    <div class="sm:px-10 mb-5">
                        <input type="checkbox" id="tick-nextmobile" class="mr-1" v-model="formInsurance.is_nextmobiles">
                        <label for="tick-nextmobile" class="cursor-pointer select-none">J’ai un iPhone reconditionné Next Mobiles</label>
                    </div>

                    <div class="flex flex-col md:flex-row w-full" v-if="!formInsurance.is_nextmobiles">
                        <div class="w-full flex flex-col sm:px-10">
                            <aff-input v-model="formInsurance.customer_number" label="Numéro d'adhérent WeCare (Inscrit sur votre carte WeCare)" placeholder="Numéro d'adhérent WeCare" type="text" :errors="errors && errors.customer_number ? errors.customer_number : null" />
                        </div>

                        <div class="flex flex-col w-full sm:px-10">
                            <label class="mb-2 italic text-gray-800">Date d'achat du smartphone</label>
                            <date-input v-model="formInsurance.product_purchased_at" :errors="errors && errors.product_purchased_at ? errors.product_purchased_at : []" />
                        </div>
                    </div>

                    <div class="flex flex-col md:flex-row w-full mb-5">
                        <div class="w-full sm:px-10 flex flex-col my-5 sm:my-0">
                            <label class="mb-1 mr-auto md:text-lg text-gray-800">Marque du smartphone</label>
                            <div class="select" v-if="!formInsurance.is_nextmobiles">
                                <select v-model="formInsurance.product_mark" class="w-full focus:shadow-outline" :class="{'errors' : errors && errors.product_mark}">
                                    <option :value="null">-</option>
                                    <option v-for="value in ['Xiaomi', 'Samsung', 'Apple']" :key="value">{{ value }}</option>
                                </select>
                            </div>

                            <div v-else>
                                <span class="text-xl font-bold">Apple</span>
                            </div>

                            <span class="mt-1 md:mt-2 mb-3 text-sm md:text-base md:font-bold" style="color: rgb(248, 64, 54);" v-if="errors && errors.product_mark">
                                <span class="block" v-for="(error, index) in errors.product_mark" :key="index">{{ error }}</span>
                            </span>
                        </div>

                        <div class="flex flex-col w-full my-5 sm:my-0 sm:px-10">
                            <label class="mb-2 italic text-gray-800">Date d'achat de la protection WeCare</label>
                            <date-input v-model="formInsurance.purchased_at" :errors="errors && errors.purchased_at ? errors.purchased_at : []" />
                        </div>
                    </div>

                    <div class="flex flex-col md:flex-row w-full">
                        <div class="w-full sm:px-10 flex flex-col">
                            <label class="mb-1 mr-auto md:text-lg text-gray-800">Modèle du smartphone</label>
                            <div class="select">
                                <select v-model="formInsurance.product_model" class="w-full focus:shadow-outline" :class="{'errors' : errors && errors.product_model}">
                                    <option :value="null">-</option>
                                    <option v-for="value in modelsForThisMark" :key="value">{{ value }}</option>
                                </select>
                            </div>

                            <span class="mt-1 md:mt-2 mb-3 text-sm md:text-base md:font-bold" style="color: rgb(248, 64, 54);" v-if="errors && errors.product_model">
                                <span class="block" v-for="(error, index) in errors.product_model" :key="index">{{ error }}</span>
                            </span>
                        </div>

                        <div class="flex flex-col w-full sm:px-10 my-5 sm:my-0">
                            <aff-input label="Numéro IMEI du smartphone" v-model="formInsurance.imei" :errors="errors && errors.imei ? errors.imei : null" type="text"/>
                            <span class="text-xs text-gray-700">Pour connaitre le numéro IMEI de l'appareil : Composez le code suivant sur le clavier de votre smartphone : *#06# Si le code ne s'affiche pas directement, appuyer sur le bouton d'appel. Indiquez le numéro de la première SIM si l'appareil comporte plusieurs SIM.</span>
                        </div>
                    </div>

                    <div class="mt-10 mx-auto flex">
                        <input type="submit" class="btn h-20 cursor-pointer border border-wecare-red bg-wecare-red hover:scale-105 hover:bg-white hover:text-wecare-red" value="Je crée mon compte" v-if="!isLoading" />

                        <span class="btn h-20 bg-wecare-red cursor-wait" v-else>
                            <svg version="1.1" class="text-white fill-current" id="loader-1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="25px" height="25px" viewBox="0 0 50 50" style="enable-background:new 0 0 50 50;" xml:space="preserve">
                                <path d="M43.935,25.145c0-10.318-8.364-18.683-18.683-18.683c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615c8.072,0,14.615,6.543,14.615,14.615H43.935z" transform="rotate(19.7256 25 25)">
                                    <animateTransform attributeType="xml" attributeName="transform" type="rotate" from="0 25 25" to="360 25 25" dur="0.6s" repeatCount="indefinite"></animateTransform>
                                </path>
                            </svg>
                        </span>
                    </div>
                </form>
            </div>

            <div class="flex flex-col w-full items-center" v-if="step == 'thanks'">
                <span class="text-4xl text-green-400 font-bold">Félicitations !</span>

                <img :src="phoneImageUrl" class="w-auto h-32 my-10" />

                <span class="text-3xl text-gray-800 mx-auto w-full text-center font-bold" style="max-width: 900px">Votre {{ formInsurance.product_mark }} {{ formInsurance.product_model }}  est assuré contre la casse pendant 12 mois à partir de la date d'achat de votre protection !</span>

                <div class="flex mx-auto mt-10">
                    <a class="btn h-20 cursor-pointer border border-green-400 bg-green-400 hover:scale-105 hover:bg-white hover:text-green-400">Lire les CGV</a>
                    
                    <div class="ml-5">
                        <router-link to="/login" class="btn h-20 cursor-pointer border border-green-400 bg-green-400 hover:scale-105 hover:bg-white hover:text-green-400">J'accède à mon compte</router-link>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import DateInput from '@/components/forms/Date'
import AffInput from '@/components/forms/Input'

import { isLoggedIn } from '@/auth'
import { activation, validateAccount } from '@/activation'

const slugify = require('slugify')

export default {
    components: { DateInput, AffInput },
    data: function () {
        return {
            isLoggedIn: isLoggedIn(),
            formAccount: {
                firstname: null,
                lastname: null,
                email: null,
                phone: null,
                address_1: null,
                address_postocde: null,
                address_city: null
            },
            formInsurance: {
                is_nextmobiles: false,
                customer_number: null,
                product_imei: null,
                purchased_at: null,
                product_purchased_at: null,
                product_mark: null,
                product_model: null
            },
            errors: null,
            step: 'account',
            isLoading: false
        }
    },
    methods: {
        submit () {
            if(this.step == 'account')
                this.validateAccount()
            
            if(this.step == 'insurance')
                this.validateAll()
        },
        validateAccount () {
            this.isLoading = true

            validateAccount(this.formAccount)
            .then(({data}) => {
                this.isLoading = false
                this.errors = null
                this.step = 'insurance'
            },
            (response) => {
                this.errors = response.response.data.errors
                this.isLoading = false
            })
        },
        validateAll () {
            this.isLoading = true

            activation(Object.assign(this.formAccount, this.formInsurance))
            .then(({data}) => {
                this.isLoading = false
                this.errors = null
                this.step = 'thanks'
            },
            (response) => {
                this.errors = response.response.data.errors
                this.isLoading = false
            })
        }
    },
    computed: {
        modelsForThisMark: function() {
            if(this.formInsurance.product_mark == 'Xiaomi')
                return ['Mi 9T', 'Mi 9T Pro', 'Redmi 8', 'Redmi Note 8T', 'Redmi 9', 'Redmi 9A', 'Redmi Note 9', 'Redmi Note 9 Pro', 'Redmi Note 9S'];

            if(this.formInsurance.product_mark == 'Samsung')
                return ['A20', 'A40', 'A50', 'S10e', 'S10+'];

            if(this.formInsurance.product_mark == 'Apple')
                return ['iPhone 7', 'iPhone 8', 'iPhone X', 'iPhone XR', 'iPhone XS'];

            return [];
        },
        phoneImageUrl() {
            if(!this.formInsurance.product_mark  || !this.formInsurance.product_model)
                return null

            return '/phones/wecare-' + slugify(this.formInsurance.product_mark + '-' + this.formInsurance.product_model, {lower: true}) + '.jpg'
        }
    },
    watch: {
        'formInsurance.product_mark': function () {
            this.formInsurance.product_model =  null;
        },
        'formInsurance.is_nextmobiles': function (value) {
            if(value) {
                this.formInsurance.product_mark = 'Apple';
            }
        }
    }
}
</script>